export { default } from './ModalContent';
